import { PROVIDER_BOOKING_CANCEL, PROVIDER_BOOKINGS } from '../../../../config';
import { DataTableHelper } from '../../../../utilities/helpers/DataTableHelper';
import axios from 'axios';

export function getBookingDetails(id) {
	return axios.get(PROVIDER_BOOKINGS + '/' + id);
}

export function getUpcomingBookings(
	sortParam,
	pageSize,
	pageNumber,
	upcoming = false,
	cancelToken,
	searchParam = '',
	createDateParam = '',
	filterStatusParams = [],
	filterPaymentStatusParams = [],
	filterChannelParams = []
) {
	return axios.get(
		(PROVIDER_BOOKINGS) +
			(upcoming
				? '?upcoming=true'
				: DataTableHelper.prepareParameters(
						sortParam,
						pageSize,
						pageNumber,
						null,
						searchParam,
						createDateParam,
						filterStatusParams,
						filterPaymentStatusParams,
						[],
						[],
						false,
						[],
						filterChannelParams
				  )),
		{ cancelToken: cancelToken }
	);
}

export function confirmBookingCancellation(confirmData) {
	return axios.post(PROVIDER_BOOKING_CANCEL, confirmData);
}

export function updateOfflineBookingPaymentStatus(id, paymentStatus) {
	return axios.put(`${PROVIDER_BOOKINGS}/offline/${id}/payment-status`, {
		payment_status: paymentStatus
	});
}

// payload: { amount (int cents), type (cash|card|bank_transfer|other), reference }
export function recordOfflineBookingPayment(id, payload) {
	return axios.post(`${PROVIDER_BOOKINGS}/offline/${id}/payments`, payload);
}

export function recordOfflineBookingRefund(id, payload) {
	return axios.post(`${PROVIDER_BOOKINGS}/offline/${id}/refunds`, payload);
}
